import { useQuery } from "react-query";
import { getOfficeLocations } from "../services/MeetingsApi";

const useExternalMeetingInfo = () => {
  return useQuery("officeLocations", () => getOfficeLocations());
};

export default useExternalMeetingInfo;
